

const TableTypeHidden = (props) => {

    return(
        <></>
    )
}

export default TableTypeHidden;